import selectorLabel from './legend.emphasis.selectorLabel'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "emphasis",
  type: "object",
  props: {
    selectorLabel,
  },
}
